import React from "react";
import { Checkbox } from "cprime-foundational-components";

interface MultiSelectOption {
  id: string | number;
  label: string;
  group?: string;
}

/**
 * cprime's Dropdown (MultiSelect/FilterMultiSelect) closes the popup when an
 * option's label is clicked but not when its checkbox is clicked, because the
 * default option click goes through the underlying Autocomplete's built-in
 * select-and-close handler. This renderOption replaces that handler entirely
 * so clicking anywhere in the row (checkbox or label) only toggles selection.
 */
export function createMultiSelectRenderOption<T extends MultiSelectOption>(
  selectedOptions: T[] | undefined,
  onChange: (updated: T[]) => void,
) {
  return (props: any, option: T, state: { selected: boolean }) => {
    const { onClick, style, ...liProps } = props;

    const toggleOption = (event: React.SyntheticEvent) => {
      event.preventDefault();
      event.stopPropagation();
      const isSelected = selectedOptions?.some((o) => o.id === option.id);
      const updated = isSelected
        ? (selectedOptions || []).filter((o) => o.id !== option.id)
        : [...(selectedOptions || []), option];
      onChange(updated);
    };

    return (
      <li
        {...liProps}
        onClick={toggleOption}
        // indent grouped sub-options to match the default grouped list layout
        style={option.group ? { ...style, paddingLeft: "2rem" } : style}
      >
        <Checkbox
          label={option.label}
          checked={!!state?.selected}
          onChange={toggleOption}
        />
      </li>
    );
  };
}

export default createMultiSelectRenderOption;
